import React from 'react';
import TextField from '@mui/material/TextField'
import { useField } from 'formik';
import { ContextSheet } from '../Context/SheetContext';

const TextfieldWrapper = ({
  name,
  ...otherProps
}) => {
  const [field, mata] = useField(name);


  const configTextfield = {
    ...field,
    ...otherProps,
    fullWidth: true,
    variant: 'outlined',
    margin: "normal",
    size: 'small'
  };

  if (mata && mata.touched && mata.error) {
    configTextfield.error = true;
    configTextfield.helperText = mata.error;
  }

  return (

    <>

      <TextField
        // error
        autoComplete="off"
        sx={{
          "& .MuiInputBase-root": {
            height: 45

          }
        }}
        {...configTextfield}

      // helperText={valueSheet.errorTextField === true ? "error" : ""}
      />


    </>
  );
};

export default TextfieldWrapper;